module.exports = __webpack_public_path__ + "img/dataV_C.db441fe3.png";